// File: src/components/common/ReCaptcha/ReCaptcha.js
import React, { useRef, useEffect } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

const ReCaptcha = ({ onChange, onError, version = 3 }) => {
    const recaptchaRef = useRef(null);

    // For reCAPTCHA v3, we need to execute the token immediately
    useEffect(() => {
        if (version === 3 && recaptchaRef.current) {
            try {
                recaptchaRef.current.execute();
            } catch (error) {
                console.error('Error executing reCAPTCHA v3:', error);
                if (onError) {
                    onError();
                }
            }
        }
    }, [version, onError]);

    const handleChange = (token) => {
        if (onChange) {
            onChange(token);
        }
    };

    const handleError = () => {
        if (onError) {
            onError();
        }
    };

    if (version === 3) {
        // For v3, reCAPTCHA is invisible, so we don't render a visible element
        return (
            <ReCAPTCHA
                ref={recaptchaRef}
                sitekey="6LcL82csAAAAAPALc6C8UYze4DHkVoOcnl-KsQnx"
                onChange={handleChange}
                onErrored={handleError}
                size="invisible"
            />
        );
    }

    // Fallback to v2 if needed
    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            marginBottom: '20px',
            transform: 'scale(0.95)',
            transformOrigin: 'center'
        }}>
            <ReCAPTCHA
                ref={recaptchaRef}
                sitekey="6LcL82csAAAAAPALc6C8UYze4DHkVoOcnl-KsQnx"
                onChange={handleChange}
                onErrored={handleError}
            />
        </div>
    );
};

export default ReCaptcha;
